const achievementsData = [
  {
    position: "3rd",
    title: "Hack Horizon Hackathon Winner",
    description: "Led Team RouteFusion to win the Hack Horizon at SRM VDP Chennai.",
    date: "March 2023",
    teamOrSolo: "Team",
    teamMembers: 4,
    role: "Team Leader",
    location: "SRM VDP Chennai",
    typeOfEvent: "Hackathon",
    skills: ["Leadership", "React", "Node.js", "UI/UX Design"],
    awards: ["cash", "bronze medal", "certificate"],
    images: [
      "https://media.licdn.com/dms/image/v2/D5622AQHvkEz5tdJMDg/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1729854705572?e=1736985600&v=beta&t=yToOi3bCqmj3SPYIYbfOBeVIfmfHew0mgxhCj_ROhq4",
      "https://media.licdn.com/dms/image/v2/D5622AQHKJY0NP07GCA/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1729854713854?e=1736985600&v=beta&t=7Z_2FGaUYdOeDYsdDQVaE-e7rlscQvs7MFdsTFxkTEU"
    ],
    additionalInfo: "Our project focused on creating an innovative solution for real-time traffic management using IoT and AI.",
    linkedinLink: "https://www.linkedin.com/posts/ramswarooppatel_hackathon-hackhorizon-srmvdp-activity-7255536552880046081-ue6X?utm_source=share&utm_medium=member_desktop" // Ensure this link is present
  },
  {
    position: "1st",
    title: "IoT Innovation Challenge",
    description: "Secured first place with my IoT agriculture monitoring system.",
    date: "June 2022",
    teamOrSolo: "Team",
    teamMembers: 4,
    role: "Developer",
    location: "Chennai, India",
    typeOfEvent: "Competition",
    skills: ["IoT", "Python", "Data Analysis"],
    awards: ["gold medal", "certificate"],
    images: ["https://thumbs.dreamstime.com/b/no-image-available-icon-flat-vector-no-image-available-icon-flat-vector-illustration-132482953.jpg"],
    additionalInfo: "Developed a system to monitor soil moisture and automate irrigation.",
  },
  { 
    position: "2nd",
    title: "Inventus",
    description: "Built an AI-based solution for public welfare, earning second place.",
    date: "September 2021",
    teamOrSolo: "Team",
    teamMembers: 4,
    role: "AI Engineer , Team Leader, Developer",
    location: "Chennai, India",
    typeOfEvent: "Hackathon",   
    skills: ["AI", "Machine Learning", "TensorFlow"],
    awards: ["cash","silver medal", "certificate"],
    images: ["https://media.licdn.com/dms/image/v2/D5622AQEUAOc59yJdVw/feedshare-shrink_1280/feedshare-shrink_1280/0/1727805676723?e=1739404800&v=beta&t=DoFKj8si8uWCkzZPo4SK_ed2nsWWwl-Hcgv0Gbe7p-8","https://media.licdn.com/dms/image/v2/D5622AQEhoNpecu8jQA/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1727805676971?e=1739404800&v=beta&t=yaQgTf_PUMYvI09An1w_z4lJonVdeSzbPRaukKZhhuc"],
    additionalInfo: "Created an AI tool to assist in disaster response by analyzing satellite images.",
    linkedinLink: "https://www.linkedin.com/posts/ramswarooppatel_hackathon-innovation-teamwork-activity-7246942268832563200-XMDE?utm_source=share&utm_medium=member_desktop"

  },
  {
    position: "3rd",
    title: "SMART INDIA HACKATHON",
    description: "Built an AI-based solution for public welfare.",
    date: "November 2024",
    teamOrSolo: "Team",
    teamMembers: 6,
    role: "AI Specialist",
    location: "Chennai, India",
    typeOfEvent: "Hackathon",   
    skills: ["AI", "Machine Learning", "TensorFlow","Python","React Native"],
    awards: [ "certificate"],
    images: ["https://media.licdn.com/dms/image/v2/D5622AQEZVbZkqo6hHg/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1729715622776?e=1739404800&v=beta&t=266AMz6miAlRw_Az0-0NcJcCtign49SmOIx2s9pPfTQ"],
    additionalInfo: "Created an AI tool to assist in disaster response by analyzing satellite images.",
    linkedinLink: "https://www.linkedin.com/posts/ramswarooppatel_i-had-the-exciting-opportunity-to-participate-activity-7254953159947624452-ejfK?utm_source=share&utm_medium=member_desktop"
  },
  
  // Add more achievements as needed
];

export default achievementsData;